// ============================================
// GEOMETRY HELPERS
// ============================================

/**
 * Move specific edges of a rectangle polygon
 * @param {Array} rings - Polygon rings
 * @param {string} direction - 'north', 'south', 'east', 'west'
 * @param {number} distanceMeters - Distance to move in meters
 * @returns {Array} New rings
 */
export const extendRectangleRings = (rings, direction, distanceMeters) => {
    if (!rings || rings.length === 0) return rings;
    const ring = rings[0]; // Assume single ring for simple structures
    if (ring.length < 4) return rings;

    // Clone ring to avoid mutation
    const newRing = ring.map(pt => [...pt]);

    // For specific N/S/E/W extension in WebMercator (which is Y-up, X-right):
    // North = +Y, South = -Y, East = +X, West = -X

    // Approach:
    // 1. Identify "extreme" points in that direction.
    // 2. Move them.

    // Let's find the bounds first
    let minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity;
    newRing.forEach(pt => {
        if (pt[0] < minX) minX = pt[0];
        if (pt[0] > maxX) maxX = pt[0];
        if (pt[1] < minY) minY = pt[1];
        if (pt[1] > maxY) maxY = pt[1];
    });

    const TOLERANCE = 0.1; // meters tolerance for "same edge"

    // Apply translation
    for (let i = 0; i < newRing.length; i++) {
        const x = newRing[i][0];
        const y = newRing[i][1];

        let shouldMove = false;

        if (direction === 'north' && Math.abs(y - maxY) < TOLERANCE) shouldMove = true;
        if (direction === 'south' && Math.abs(y - minY) < TOLERANCE) shouldMove = true;
        if (direction === 'east' && Math.abs(x - maxX) < TOLERANCE) shouldMove = true;
        if (direction === 'west' && Math.abs(x - minX) < TOLERANCE) shouldMove = true;

        if (shouldMove) {
            if (direction === 'north') newRing[i][1] += distanceMeters;
            if (direction === 'south') newRing[i][1] -= distanceMeters;
            if (direction === 'east') newRing[i][0] += distanceMeters;
            if (direction === 'west') newRing[i][0] -= distanceMeters;
        }
    }

    return [newRing];
};
